// (c) chaehongee. Confidential and proprietary.

import { http, buildApiUrl } from './http'

export interface ResetResponse {
    status: string
    [k: string]: unknown
}

export async function resetSystem(): Promise<ResetResponse> {
    return http<ResetResponse>(buildApiUrl('/system/reset'), { method: 'DELETE' })
}

export async function resetSession(sessionId: string): Promise<ResetResponse> {
    return http<ResetResponse>(buildApiUrl(`/system/reset/${sessionId}`), {
        method: 'DELETE',
    })
}



